export enum FormType {
    Invalid = 0,
    ScopeOfAppointment = 1,
    Paper = 2,
    OfflineApplication = 3,
}
